import React, { Component } from 'react';

class Tooltip extends Component {
  render() {
    return(
      <div className='tooltip'>Hanja syllables you unlock are kept here.
      <br />You unlocked <b>남</b> already, select it below to start learning words related to it.</div>
    )
  }
}
export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/tooltip.js